function toggleProfileOrder() {
  let button = $('.profile__toggle');
  button.on('click', function() {
    $(this).closest('.profile__order').toggleClass('active');
    $(this).toggleClass('active');
  });
}
toggleProfileOrder();